import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { API_BASE_URL } from '@core/injectors';
import { DepartmentsDTO } from '@core/models';
import { map, Observable } from 'rxjs';
import { UserService } from '../user/user.service';

@Injectable({
  providedIn: 'root',
})
export class CommonDepartmentsDataService {
  organizationHasMultipleDepartments = signal<boolean>(true);
  get hasAccessToAllDepartments(): boolean | undefined {
    return this.userService.isUserHaveAccessToAllDepartments;
  }

  get userDepartments(): DepartmentsDTO[] | undefined {
    return this.userService.listUserDepartments;
  }

  constructor(
    private readonly http: HttpClient,
    private readonly userService: UserService,
    @Inject(API_BASE_URL) private readonly apiBaseUrl: string,
  ) {
    this.hasMultipleDepartments().pipe(takeUntilDestroyed()).subscribe();
  }

  getDepartments(): Observable<DepartmentsDTO[]> {
    return this.http.get<DepartmentsDTO[]>(`${this.apiBaseUrl}/api/departments/`);
  }

  hasMultipleDepartments(): Observable<boolean> {
    return this.getDepartments().pipe(
      map((departments) => {
        const departmentsMoreThanOne = departments.length > 0;
        this.organizationHasMultipleDepartments.set(departmentsMoreThanOne);
        return departmentsMoreThanOne;
      }),
    );
  }

  hasCommonDepartments(elementDepartments: DepartmentsDTO[], elementAllDepartmentsAccess: boolean): boolean {
    if (elementAllDepartmentsAccess) {
      return true;
    }

    if (!this.organizationHasMultipleDepartments()) {
      return true;
    }

    if (this.hasAccessToAllDepartments) {
      return true;
    }

    return this.userDepartments?.length
      ? this.userDepartments.some((userDept) => (elementDepartments || []).some((dsDept) => userDept.id === dsDept.id))
      : false;
  }
}
